<ng-container *ngIf="licenseUpgradePurchaseFlagOn">
	<ng-container *ngIf="license$ | async as license">
		<!-- Do not show this breadcrumb while license expiration breadcrumb is shown -->
		<ng-container *ngIf="!licenseExpirationHandler.isExpiringLicenseRequiringWarning(license)">
			<license-plan-badge
				*ngIf="shouldShowBadge(license)"
				class="license-plan-badge-breadcrumb"
				[loading]="loading$ | async"
				[license]="license"
				(actionClick)="licensePlanBadgeClicked(license)"
				[hideAction]="!!license.salesforce_license?.has_renewal"
			>
			</license-plan-badge>
		</ng-container>
	</ng-container>
</ng-container>
